/**
 * Лінивий модуль браузерної підписки Web Push (`push-device.ts`): одна точка `import()` для
 * оболонки, повторного входу й виходу — першому екрану він не потрібен (бюджет 200 КБ). Збій чанка —
 * як збій браузера: `null`, наступний старт спробує ще.
 */
export const loadPushDevice = () => import('./push-device.ts').catch(() => null);
